import { stripe } from '../constants/actions'

const initialState = {
  paymentIntent: null,
  clientSecret: null,
  stripeKey: null,
  paymentStatus: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case stripe.SET_PAYMENT_INTENT:
      if (!action.payload) {
        return initialState
      }

      return {
        ...state,
        ...action.payload,
      }
    case stripe.SET_PAYMENT_STATUS:
      return {
        ...state,
        paymentStatus: action.payload,
      }
    default:
      return state
  }
}
